var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconCollectionSolid extends Component {
  constructor() {
    super(...arguments);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconCollection",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1242.353 677.647V1920H0V677.647h1242.353Zm-338.824 790.588H338.824v112.941h564.705v-112.94Zm677.647-1129.411v1242.352h-225.882V564.706H338.824V338.824h1242.352Zm-790.475 903.529H338.824v112.941H790.7v-112.941ZM1920.034-.011v1242.353h-225.882V225.872H677.68V-.012h1242.353ZM903.529 1016.47H338.824v112.94h564.705v-112.94Z",
      fillRule: "evenodd"
    })));
  }
}
IconCollectionSolid.glyphName = 'collection';
IconCollectionSolid.variant = 'Solid';
IconCollectionSolid.displayName = 'IconCollectionSolid';
IconCollectionSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconCollectionSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconCollectionSolid;
export { IconCollectionSolid };